import { postApacheUserToken } from "@/services/Login";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

const DASHBOARD_ID = import.meta.env.VITE_APACHE_ADMIN_DASHBOARDID;
const SUPERSET_URL = import.meta.env.VITE_APACHE_URL;

const ReportsAdmin = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const { mutateAsync: getApacheUserToken } = useMutation({
    mutationFn: (uuid: string) => postApacheUserToken(uuid, "no"),
  });

  useEffect(() => {
    async function loadDashboard() {
      if (!containerRef.current) return;
      await embedDashboard({
        id: DASHBOARD_ID,
        supersetDomain: SUPERSET_URL,
        mountPoint: containerRef.current,
        fetchGuestToken: async () => await getApacheUserToken(DASHBOARD_ID).then((res) => res.data.token),
        dashboardUiConfig: {
          filters: { visible: true },
          hideTitle: true,
          hideChartControls: true,
        },
      });

      const iframe = containerRef.current.querySelector("iframe");
      if (iframe) {
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.border = "none";
        iframe.style.display = "block";
      }
    }

    loadDashboard().then();
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100vw",
        height: "85vh",
        border: "none",
        overflow: "hidden",
      }}
    />
  );
};

export default ReportsAdmin;
